import { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Link as Linkscroll, animateScroll as Scroll } from "react-scroll";
import { useParams, useHistory } from "react-router-dom";
import logoHeader from "../../assets/logo.png";
import ModalContacto from "../ModalContacto/ModalContacto";
import { useLocation } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import { collection, docs, getDocs } from "firebase/firestore";
import { buildRouteWithUtms } from "../../config/whatsappConfig";

const Header = ({ vehicles }) => {
  // const [vehicles, setVehicles] = useState([]);
  // const db = getFirestore();

  // useEffect(() => {
  //   const cargarVehiculos = async () => {
  //     // Verificar si los datos ya están en localStorage
  //     const datosLocales = sessionStorage.getItem("vehicles");
  //     if (datosLocales) {
  //       // Parsear los datos de localStorage y establecerlos en el estado
  //       setVehicles(JSON.parse(datosLocales));
  //     } else {
  //       // Si no están en localStorage, obtenerlos de Firebase
  //       try {
  //         const querySnapshot = await db.collection("ford").get();
  //         const arrayVehicles = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  //         setVehicles(arrayVehicles);
  //         // Almacenar los datos en localStorage
  //         sessionStorage.setItem("vehicles", JSON.stringify(arrayVehicles));
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   };

  //   // Llamar a la función para cargar datos
  //   cargarVehiculos();
  // }, [db]);

  const [modalShow, setModalShow] = useState(false);

  let location = useLocation();

  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let history = useHistory();
  let { tipo } = useParams();

  useEffect(() => {
    const validTipos = ["todos", "convencional", "plan", "grandesclientes", "preventa"];
    const search = location.search;

    if (!tipo || !validTipos.includes(tipo)) {
      history.replace(buildRouteWithUtms("/todos", search));
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "preventa") {
      setFiltrados(vehicles.filter((item) => item?.preventa?.habilitado === true));
    }

    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "grandesclientes") {
      setFiltrados(vehicles.filter((item) => item.grandesclientes && item.grandesclientes.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  window.dataLayer = window.dataLayer || [];

  const handlePedirPresupuesto = () => {
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });

    setModalShow(true);
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header">
          <Col md={6} xs={12} className="text-sm-start text-center pt-3">
            <Link to={buildRouteWithUtms("/todos", location.search)}>
              <img src={logoHeader} alt="Montironi Peugeot" className="img-fluid" />
            </Link>
          </Col>
          <Col
            md={6}
            xs={12}
            className="text-sm-start text-center pt-4 justify-content-md-end justify-content-center d-md-flex d-none"
          >
            {location.pathname === "/todos" ? (
              <Linkscroll to="scroll-click" className="link-header px-sm-3" style={{ cursor: "pointer" }}>
                Modelos
              </Linkscroll>
            ) : (
              <Link to={buildRouteWithUtms("/todos", location.search)} className="link-header px-sm-3">
                Modelos
              </Link>
            )}

            <Button className="btn-blue ms-md-4" onClick={() => handlePedirPresupuesto()}>
              Pedir presupuesto
            </Button>
          </Col>
        </Row>
      </Container>
      <ModalContacto
        filtrados={filtrados}
        tipoPlan="convencional"
        vMarca="Ford"
        vModelo={null}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </Container>
  );
};

export default Header;
